import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Lightning } from '@phosphor-icons/react';
import useThemeStyles from '../../theme/useThemeStyles';

function AutomationsPage() {
  const styles = useThemeStyles();
  return (
    <Box sx={{ width: '100%', py: { xs: 3, md: 6 } }}>
      <Paper
        elevation={0}
        sx={{
          maxWidth: 760,
          mx: 'auto',
          p: { xs: 3, md: 5 },
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
          textAlign: 'center',
          backgroundColor: 'background.paper',
        }}
      >
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
          <Lightning size={40} weight="regular" />
        </Box>
        <Typography component="h2" className="pagename" sx={{ ...styles.text.pagename, mb: 2 }}>
          Automated Workflows
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 640, mx: 'auto' }}>
          Build automated workflows that trigger emails, reminders, and actions the moment
          something happens in your account.
        </Typography>
        <Button variant="contained" disabled>
          Coming Spring 2026
        </Button>
      </Paper>
    </Box>
  );
}

export default AutomationsPage;
